// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"b26cdc5bcbc27c5d","5285":"7e11b3bdf6b3834d"}[chunkId] + ".css";
};